import {getDefaultPowerSourcesData, IPowerSource} from '../../../data/data';
import * as _ from 'lodash';
import {AnyAction} from 'redux';
import {CLEAR_ALL_DAMAGE, REPAIR_STATION_AT_LOCATION, SET_INITIAL_DAMAGE} from '../../actions/action';
import {createSelector} from 'reselect';

export const getDamage = state => state.damage;
const getLocationID = (state, props: { location_id: number }) => props.location_id;


/**
 * check whether the power source at a location has been damaged by an event
 */
export const isPowerSourceDamaged = createSelector(

    [getDamage, getLocationID],

    (damage: boolean[], location_id: number) : boolean =>
    {
        return damage[location_id] === true;
    }
);


const initial_state: boolean[] = _.fill(Array(50), undefined);


/**
 * reducer: keep track of which stations are damaged
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function damage(state = initial_state, action: AnyAction) : typeof initial_state
{
    switch (action.type)
    {
        case CLEAR_ALL_DAMAGE:
        {
            return initial_state.slice(0);
        }

        case SET_INITIAL_DAMAGE:
        {
            const {payload} = action;
            const {damaged} = payload;

            // console.group('damage: SET_INITIAL_DAMAGE');
            // console.log('damage', damaged);
            // console.groupEnd();

            return damaged;
        }

        case REPAIR_STATION_AT_LOCATION:
        {
            const {payload} = action;
            const {location_id} = payload;

            return [
                ...state.slice(0, location_id),
                false,
                ...state.slice(location_id + 1)
            ];
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/power-sources/damage.ts